/**
 * Created by tatyana on 07/06/2017.
 */

export const CUSTOM_PARAM_SOURCES = {
	VAR : 'var',
	URL : 'url',
	COOKIE : 'cookie',
};

export const TYPES = {
	NUMBER : 'Number',
	BOOLEAN : 'Boolean'
};

export const DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
};

export const DEFAULT_HOSTING_ELEMENT_ID = 'default_id_preview';
